import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import ConfirmStandardization from '@/components/caisse/factures/confirm-invoice-standardization'
import InfoOperationRST from '@/components/caisse/factures/info-operation'
import { NumberToLetter } from 'convertir-nombre-lettre';
import { cca_config } from '../../../../../CCA_ENV_CONF/env';
import $ from 'jquery'

import QrcodeVue from 'qrcode.vue'

export default {
    name: 'view-facture',
    components: {
        EnteteBonEtFacture,
        QrcodeVue, ConfirmStandardization, InfoOperationRST
    },
    props: [],
    data() {
        return {
            is_printing: false,
            info_is_loading: true,
            info_error_load: false,
            est_assure: false,

            billing_operations: [],

            is_printable: false,
            
            toggle_payment_state: 0,
            part_assureur: 0,
            
            info_assurance: {},
            prestations: [],
            compte_id: 0,
            total_net: 0,
            filename: '',
            montant_en_lettre: '',
            nom_clinique: '',

            qrcode_size: 90,

            type_factures: [],
            all_type_factures: [],

            selected_type_facture: {},
            selected_type_paiement: {},
            type_facture_loading: true,
            type_espece_loading: true,
            invoice_data: {},
            modal_state_toggler: 0,

            tot_base_assurance: 0,
            total_prix_assureur: 0,
            total_prix_assure: 0,
            can_print: false,
            info_operation: {},

            colspans: {
                colspan_1: '',
                colspan_2: '',
                colspan_3: '',
                colspan_4: '',
            },
            sign: '',
            divers_info_loading: true
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },

        selected_facture() {
            return this.$store.getters['selected_facture'];
        },

        patient() {
            return this.$store.getters['patient']
        },

        patient_insurance_info() {
            return this.$store.getters['patient_insurance_info']
        },

        sfe_type_facture() {
            return this.$store.getters['sfe_type_facture'];
        },

        sfe_type_paiement() {
            return this.$store.getters['sfe_type_paiement'];
        },

        divers_info() {
            return this.$store.getters["divers_info"];
        },
    },

    mounted() {
        if (this.has_two_currencies) {
            this.currency_info = this.$store.getters['info_currency']
        }
        
        this.nom_clinique = cca_config.NOM_CLINIQUE
        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        if (this.is_sfe) {
            if (this.selected_facture.mecef_info.type_facture == 'FA' || this.selected_facture.mecef_info.type_facture == 'EA') {
                this.sign = '-'
            }
        }

        this.setColspans()

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js

        // Type facture SFE
        this.getTypeFacturesSFE()

        // Type paiement SFE
        this.getTypePaiementSFE()


        if (this.selected_facture.length == 0) {
            this.$router.push({ path: '/factures' })
        }
        if (this.selected_facture.patient_id > 0) {
            this.getInsuranceInfo()
        }

        this.calculateBill()

        const tmpstamp = this.current_date.getTime()
        this.filename = 'Facture_'+this.selected_facture.info_patient.patient+'_'+tmpstamp

        this.getDiversInfo()
    },

    methods: {
        getDiversInfo() {
            this.divers_info_loading = true
            this.$store.dispatch('getConfigInfoClinique', 'divers_info').then(() => {

                this.divers_info_loading = false
            })
        },

        setColspans() {
            if (cca_config.IS_SFE) {
                if (this.can_set_pac) {
                    this.colspans.colspan_1 = 13
                    this.colspans.colspan_3 = 12
                } else {
                    this.colspans.colspan_1 = 11
                    this.colspans.colspan_3 = 10
                }
                this.colspans.colspan_4 = 6
            } else {
                if (this.can_set_pac) {
                    this.colspans.colspan_2 = 12
                    this.colspans.colspan_3 = 11
                } else {
                    this.colspans.colspan_2 = 10
                    this.colspans.colspan_3 = 9
                }
                this.colspans.colspan_4 = 5
            }
        },

        getTypeFacturesSFE() {
            const data = {
                data_type: 'invoice_type',
                endpoint: 'invoiceTypes'
            }
            this.type_facture_loading = true
            this.$store.dispatch('getInfoSFE', data).then(() => {
                this.sfe_type_facture.forEach(bill_type => {

                    // Tous les types de facture
                    this.all_type_factures.push({
                        description: bill_type.description,
                        type: bill_type.type
                    })
                    
                    if (bill_type.type === 'FV' || bill_type.type === 'EV') {
                        const tmp_aib = {
                            description: bill_type.description,
                            type: bill_type.type
                        }
                        this.type_factures.push(tmp_aib)

                        if (bill_type.type === 'FV') {
                            this.selected_type_facture = tmp_aib
                            this.type_facture_loading = false
                        }
                    }
                });
                
            })
        },

        getTypePaiementSFE() {
            const data = {
                data_type: 'payment_type',
                endpoint: 'paymentTypes'
            }
            this.type_espece_loading = true
            this.$store.dispatch('getInfoSFE', data).then(() => {
                this.selected_type_paiement = this.sfe_type_paiement[0]
                this.type_espece_loading = false
            })
        },

        getLibelleTypeFacture(type_facture_abv) {
            let libelle = ''

            this.all_type_factures.forEach(type_facture => {
                if (type_facture.type == type_facture_abv) {
                    libelle = type_facture.description
                }
            });
            return libelle
        },

        getInsuranceInfo() {
            this.info_is_loading = true
            this.$store.dispatch('getPatientInsuranceInfo', this.selected_facture.patient_id).then(() => {
                this.info_assurance = {
                    taux_couverture: '',
                    est_assure: this.patient_insurance_info.est_assure,
                    est_expire: this.patient_insurance_info.contrat_a_expire,
                    assurance_id: (this.patient_insurance_info.assur_id != null)?this.patient_insurance_info.assur_id:'',
                    assurance: this.patient_insurance_info.assur_nom,
                    souscripteur_id: (this.patient_insurance_info.souscripteur_id != null)?this.patient_insurance_info.souscripteur_id:'',
                    souscripteur: (this.patient_insurance_info.souscripteur != null)?this.patient_insurance_info.souscripteur:'',
                    assure_principal_id: (this.patient_insurance_info.assure_principal_id != null)?this.patient_insurance_info.assure_principal_id:'',
                }

                this.info_is_loading = false
            }).catch(() => {
                this.info_error_load = true
                this.info_is_loading = false
            })
        },

        calculateBill() {
            this.total_net = 0
            this.tot_base_assurance = 0
            this.total_prix_assureur = 0
            this.total_prix_assure = 0

            this.selected_facture.operations.forEach((operation) => {
                operation.prestations.forEach(prestation => {
                    let montant = 0
                    montant = prestation.montant_paye
                    if (prestation.data_type == 'apport_social') {
                        montant = -montant
                    }

                    if (prestation.base_assurance != null){
                        this.tot_base_assurance += (parseInt(prestation.base_assurance) * prestation.qte)
                    }
                    
                    this.total_prix_assureur += prestation.part_assureur

                    this.total_net += montant
                });
            });
            this.total_prix_assure = this.selected_facture.montant
            this.montant_en_lettre = NumberToLetter(this.selected_facture.montant)
        },

        setInvoiceData(type_facture) {
            this.modal_state_toggler = (this.modal_state_toggler == 0)?1:0
            let type_aib = ''
            if (this.selected_facture.mecef_info.operation_aib != 'n_a') {
                if (this.selected_facture.mecef_info.operation_aib == 'aibA') {
                    type_aib = 'A'
                } else if (this.selected_facture.mecef_info.operation_aib == 'aibB') {
                    type_aib = 'B'
                }
            }

            let billing_operations = []

            this.selected_facture.operations.forEach((operation) => {
                operation.prestations.forEach(prestation => {
                    billing_operations.push(prestation)
                });
            });

            this.invoice_data = {
                is_standardized: (type_facture == 'avoir')?1:0,
                facture_id: this.selected_facture.mecef_info.facture_id,
                code_mecef: this.selected_facture.mecef_info.code_mecef,
                user_id: this.userCredentials.user.id,
                patient_id: this.selected_facture.patient_id,
                operations: billing_operations,
                montant: this.selected_facture.montant,
                operator: {
                    "name": cca_config.NOM_CLINIQUE
                },
                payment: {
                    "name": this.selected_type_paiement.type,
                    "amount": this.selected_facture.montant
                },
                client: {
                    "ifu":  this.selected_facture.mecef_info.ifu_client,
                    "name": this.selected_facture.mecef_info.nom_client
                },
                aib: type_aib,
                type: this.selected_type_facture.type,
                type_facture: type_facture,
                info_patient: {
                    nom_patient: this.patient.nom_patient,
                    sexe: this.patient.sexe,
                    telephone: this.patient.telephone_mobile,
                    num_dossier: this.patient.num_dossier,
                    age: this.patient.age
                },
                info_caissier: {
                    nom_caissier: this.userCredentials.user.name,
                    titre: this.userCredentials.user.titre
                }
            }
        },

        printInvoice() {
            this.can_print = true

            setTimeout(() => {
                
                window.print()
                this.can_print = false
            }, 500);
        },

        viewInfo(info_operation) {
            this.info_operation = info_operation

            setTimeout(() => {
                $('.p-info-rst-'+info_operation.id).modal('show')
            }, 500);
        },
    }
}